import React from 'react';
import ScreensLanding from '../../shared/pages/components/landing/ScreensLanding';
import { screensIndustryLandingOptions } from './constants/screensIndustryLandingOptions';
import { ViewType } from '../../../../shared/entities/view/components/view/enums/ViewType';

const ScreensIndustryLanding: React.FC = () => {
  return <ScreensLanding landingType={ViewType.IndustryLanding} options={screensIndustryLandingOptions} />;
};

export default ScreensIndustryLanding;
